const customImages = document.querySelectorAll('.deepsea-image-figure img');

Array.from(customImages).forEach((img) => {
  const width = img.getAttribute('width');
  const height = img.getAttribute('height');

  if (width) {
    img.style.setProperty('--img-width', `${width}px`);
  }

  if (height) {
    img.style.setProperty('--img-height', `${height}px`);
  }
});
